import { TAddress } from 'models';

export const getAddedTypes = (addresses: TAddress[]) => {
  const addedTypes: string[] = [];

  addresses.forEach((item) => !item.deleted && addedTypes.push(...item.props.type));

  return addedTypes;
};
